module.exports = __webpack_public_path__ + "static/media/QX9770.a79b92ef.jpg";